import { message } from "antd";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { GET_ITEM_ENDPOINT } from "../../../apiServices/API_ENDPOINTS";
import { getData } from "../../../apiServices/common";
import { onDeleteItem, onGetItemList } from "../../../redux/actions";
import CreateItem from "../CreateItem";
import ListItem from "./ListItem";

const ItemList = (props) => {
  const {
    itemList,
    categoryList,
    form,
    currentPage,
    setCurrentPage,
    showFilter,
    setShowFilter,
  } = props;
  const dispatch = useDispatch();
  const totalItemList = useSelector(({ item }) => item.totalItem);
  const pageSize = useSelector(({ item }) => item.pageSize);
  const filterData = useSelector(({ filter }) => filter.filterData);
  const [toDeleteItem, setToDeleteItem] = useState(null);
  const [isAddItem, onSetAddItem] = useState(false);
  const [isShowDetail, onShowDetail] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [attributeInfo, setAttributeInfo] = useState(null);

  const handleAddItemOpen = () => {
    onSetAddItem(true);
  };

  const onPageChange = (newPage) => {
    setCurrentPage(newPage);
  };

  const handleAddItemClose = () => {
    onSetAddItem(false);
    setSelectedItem(null);
  };

  const onViewItemDetail = (Item) => {
    setSelectedItem(Item);
    onShowDetail(true);
  };

  const onOpenEditItem = (event, Item) => {
    setSelectedItem(Item);
    handleAddItemOpen();
  };

  const onUpdateItem = (Item) => {
    setSelectedItem(Item);
    const attribute_infos = Item?.category_info?.attribute_info;
    const attribute_value_infos = Item?.category_info?.attribute_value_info;
    setAttributeInfo(attribute_infos);
    let attribute_info_array = [];

    attribute_infos &&
      attribute_infos.forEach((item, index) => {
        attribute_value_infos &&
          attribute_value_infos.foreach((value, idx) => {
            if (value.attribute_id !== item.id) {
              attribute_info_array.push({
                attribute_id: item?.id,
                attribute_name: item?.name,
                attribute_value: "N/A",
              });
            }
          });
      });
    handleAddItemClose();
  };

  const onSelectItemForDelete = (Item) => {
    setToDeleteItem(Item);
  };

  // Fixed delete handler
  const onSelectedItemToDelete = async (record) => {
    try {
      await dispatch(onDeleteItem(record));
      setToDeleteItem(null);

      // Refresh the data after successful deletion
      dispatch(
        onGetItemList({
          page: currentPage,
          per_page: 10,
          ...filterData,
        }),
      );

      if (props.refetch) {
        props.refetch();
      }

      message.success("Item deleted successfully");
    } catch (error) {
      message.error("Error deleting item");
      console.error("Delete error:", error);
    }
  };

  useEffect(() => {
    dispatch(
      onGetItemList({
        page: currentPage,
        per_page: 10,
        ...filterData,
      }),
    );
  }, [props.refresh, currentPage, filterData, dispatch]);

  // Fixed copy function
  const copyItem = async (item) => {
    try {
      const customQuery = `${GET_ITEM_ENDPOINT}/${item?.id}/copy`;
      const bodyData = {};

      const response = await getData(customQuery, false, bodyData);

      if (response?.status === 200) {
        // Refresh the list after successful copy
        dispatch(
          onGetItemList({
            page: currentPage,
            per_page: 10,
            ...filterData,
          }),
        );

        if (props.refetch) {
          props.refetch();
        }

        message.success("Item copied successfully");
      } else {
        message.error("Error copying item data");
      }
    } catch (error) {
      message.error("Error copying item data");
      console.error("Copy error:", error);
    }
  };

  // Create a refresh handler to pass down
  const handleRefresh = () => {
    dispatch(
      onGetItemList({
        page: currentPage,
        per_page: 10,
        ...filterData,
      }),
    );
    if (props.refetch) {
      props.refetch();
    }
  };

  return (
    <>
      <ListItem
        itemList={itemList}
        categoryList={categoryList}
        extra={props.extra}
        page={currentPage}
        pageSize={pageSize}
        totalItemList={totalItemList}
        onPageChange={onPageChange}
        handleAddItemOpen={handleAddItemOpen}
        handleAddItemClose={handleAddItemClose}
        onSelectItemForDelete={onSelectItemForDelete}
        onViewItemDetail={onViewItemDetail}
        onOpenEditItem={onOpenEditItem}
        onSelectedItemToDelete={onSelectedItemToDelete}
        selectedItem={selectedItem}
        copyItem={copyItem}
        showFilter={showFilter}
        setShowFilter={setShowFilter}
        onRefresh={handleRefresh}
      />

      <CreateItem
        itemList={itemList}
        categoryList={categoryList}
        refetch={handleRefresh}
        isAddItem={isAddItem}
        handleAddItemClose={handleAddItemClose}
        selectedItem={selectedItem}
        onUpdateItem={onUpdateItem}
        onSuccess={handleRefresh}
      />
    </>
  );
};

export default ItemList;
